import { useEffect, useRef, type ReactNode } from "react";
import { useTranslation } from "react-i18next";

export function AccessDrawer({ title, onClose, children }: { title: string; onClose: () => void; children: ReactNode }) {
  const { t } = useTranslation();
  const panel = useRef<HTMLElement>(null);
  const close = useRef(onClose); close.current = onClose;
  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null;
    const priorOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    panel.current?.focus();
    const keyboard = (event: KeyboardEvent) => {
      if (event.key === "Escape") { event.preventDefault(); close.current(); }
      if (event.key !== "Tab") return;
      const controls = [...(panel.current?.querySelectorAll<HTMLElement>("button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), [tabindex='0']") ?? [])];
      const first = controls[0]; const last = controls.at(-1);
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel.current)) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || document.activeElement === panel.current)) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener("keydown", keyboard);
    return () => { document.body.style.overflow = priorOverflow; document.removeEventListener("keydown", keyboard); previous?.focus(); };
  }, []);
  return <div className="access-drawer-backdrop">
    <button type="button" className="access-drawer-scrim" tabIndex={-1} aria-label={t("access.close", "Close")} onClick={onClose} />
    <aside ref={panel} tabIndex={-1} className="access-explanation" role="dialog" aria-modal="true" aria-labelledby="access-drawer-title">
      <header className="access-row-head"><h2 id="access-drawer-title">{title}</h2><button className="btn" type="button" onClick={onClose}>{t("access.close", "Close")}</button></header>
      {children}
    </aside>
  </div>;
}
